import { searchRequestData } from "../../Utility/apiHelper";
import * as actionType from "./type";

export const requestGetTelecallingDetails = (queryparams) => async(dispatch)=>{

    try{
        dispatch({
            type: actionType.REQUEST_TELECALLING_DETAILS_
        })
            const url = `${process.env.REACT_APP_BASE_URL}api/telecalling`;
            const responsedata = await searchRequestData(queryparams , url , false)
            if(responsedata?.status === 200){
        dispatch({
            type: actionType.RECEIVED_TELECALLING_DETAILS_,
            payload: responsedata?.data
        })
    }
    }
    catch(error){
        
    }


}